import React from 'react';

import Table from '@/components/ui/tables/Table';
import { FilterDropdown } from '@/components/ui/filters/FilterDropdown';
import { ExportDropdown } from '@/components/ui/filters';
import { useTranslation } from '@/i18n';
import { useRoleAssignedEmployeesList } from '@/hooks/authorization/useRoleAssignedEmployeesList';
import { useRoleAssignedEmployeesExport } from '@/hooks/authorization/useRoleAssignedEmployeesExport';


export const AssignedEmployeesForm: React.FC = () => {
  const { t: translate } = useTranslation();
  const {
    rows,
    total,
    page,
    pageSize,
    setPage,
    setPageSize,
    filters,
    setFilters,
    filterConfig,
    columns,
    actions,
    onSearch,
    onSortChange,
    loading,
    debouncedSearchText,
  } = useRoleAssignedEmployeesList();

  const { exportAssignments, isExporting } = useRoleAssignedEmployeesExport({
    status: filters.status,
    searchText: debouncedSearchText || undefined,
  });

  return (
    <div className="flex flex-col gap-6" data-testid="assigned-employees-tab">
      <div className="flex justify-between items-start">
        <div className="flex flex-wrap gap-4">
          <FilterDropdown
            filters={filterConfig}
            values={{
              status: filters.status,
            }}
            onChangeFilter={(key, value) => {
              setFilters((previous) => ({
                ...previous,
                [key]: value,
              }));
            }}
          />
        </div>
        <ExportDropdown
          onExport={exportAssignments}
          placement="right"
          isLoading={isExporting}
          disabled={total === 0 || isExporting}
          availableFormats={['EXCEL']}
        />
      </div>

      <Table
        columns={columns}
        actions={actions}
        data={rows}
        totalRows={total}
        searchable
        onSearch={onSearch}
        onSortChange={onSortChange}
        serverSideSort
        columnMaxWidth={150}
        emptyMessage={translate('authorization:assigned.messages.noResults')}
        pagination={{
          page,
          pageSize,
          total,
          onChange: setPage,
          onPageSizeChange: setPageSize,
        }}
        data-testid="assigned-employees-table"
        isLoading={loading}
      />
    </div>
  );
};

export default AssignedEmployeesForm;
